import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '../../layouts/Default';
import Section from '../../components/Section';
import PublisherContactUs from '../../components/PublisherContactUs/PublisherContactUs';
import ValueForCustomers from '../../components/ValueForCustomers/ValueForCustomers';
import DigitaliseMaterial from '../../components/DigitaliseMaterial/DigitaliseMaterial';
import NualangForPublishers from '../../components/NualangForPublishers/NualangForPublishers';
import SupportForPublishers from '../../components/SupportForPublishers/SupportForPublishers';
import useContentLanguageSwitcher from '../../hooks/useContentLanguageSwitcher';
import content from '../../../content/publishers/index';

const section = (theme) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(8),
  },
  paddingBottom: theme.spacing(8),
});

export const PublishersPageTemplate = ({
  helmet,
  content,
}) => (
    <>
      {helmet || ''}
      <NualangForPublishers
        {...content.infoForPublishers}
      />
      <Section
        sx={section}
      >
        <SupportForPublishers {...content.supportForPublishers} />
      </Section>
      <Section
        sx={section}
      >
        <DigitaliseMaterial {...content.digitaliseMaterial} />
      </Section>
      <Section
        sx={section}
      >
        <ValueForCustomers {...content.valueForCustomers} />
      </Section>
      {/* <Section
        sx={section}
      >
        <DigitaliseContent {...content.digitaliseContent} />
      </Section> */}
      <Section
        sx={section}
      >
        <PublisherContactUs {...content.publisherContactUs} />
      </Section>
    </>
);

PublishersPageTemplate.propTypes = {
  helmet: PropTypes.object,
  content: PropTypes.object,
};

function Publishers(props) {
  const {
    data: {
      site: {
        siteMetadata: { title },
      },
    },
  } = props;

  const [publishersPageData] = useContentLanguageSwitcher({ content });

  return (
    <Layout>
      <PublishersPageTemplate
        helmet={
          <Helmet title={`Publishers | ${title}`} />
        }
        content={publishersPageData}
      />
    </Layout>

  );
}

Publishers.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.object,
  }),
};

export default Publishers;

export const publishersPageQuery = graphql`
  query PublishersQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
